import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Card } from "primereact/card";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { addLocale } from "primereact/api";
import { format, parse } from "date-fns";
import { isAfter, isBefore, addDays, subDays } from "date-fns";
import NominaContext from "../context/NominProvider";

export const Faltas = () => {
       const { selectedNomina } = React.useContext(NominaContext);

  const { selectedNominaId } = useOutletContext();
  const [nominas, setNominas] = React.useState([]);
//    const selectedNomina = nominas.find(x => x.idNomina === selectedNominaId) || null;
  
  const navigate = useNavigate();
  const toast = useRef(null);
  const [empleados, setEmpleados] = useState([]);
  const [empleado, setEmpleado] = useState();
  const [fechas, setFechas] = useState([]);
  const [fechaInicial, setFechaInicial] = useState(null);
  const [fechaFinal, setFechaFinal] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const { idFalta } = useParams();
  const [configSistema, setConfigSistema] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await axiosPrivate.get("/NOM/configuracion/sistema");
        setConfigSistema(res.data);
      } catch (err) {
        console.error("Error al obtener configuración", err);
      }
    };

    fetchConfig();
  }, []);

  const getData = async () => {
    if (!selectedNomina) return;

    console.log("Obteniendo empleados para la get:", selectedNomina);

    const response = await axiosPrivate.get(
      "/NOM/empleados/select/" + selectedNomina.idNomina
    );

    if (response) {
      console.log(response);
      const data = response.data;
      setEmpleados(data);
    }
  };

  useEffect(() => {
    if (!selectedNomina) return;
    getData();
  }, [selectedNomina]);

  useEffect(() => {
    if (!selectedNomina || !configSistema) return;

    const inicioPeriodo = parse(
      selectedNomina.FechaInicial,
      "dd/MM/yyyy",
      new Date()
    );
    const finPeriodo = parse(
      selectedNomina.FechaFinal,
      "dd/MM/yyyy",
      new Date()
    );

    const configFaltas = configSistema.faltas || {};
    console.log("Config Faltas:", configFaltas);
    let min = inicioPeriodo;
    let max = finPeriodo;

    switch (configFaltas?.validacionFechas) {
      case "periodo":
        // Ya está cubierto
        min = inicioPeriodo;
        max = finPeriodo;
        break;
      case "mes":
        const firstDay = new Date(
          inicioPeriodo.getFullYear(),
          inicioPeriodo.getMonth(),
          1
        );
        const lastDay = new Date(
          inicioPeriodo.getFullYear(),
          inicioPeriodo.getMonth() + 1,
          0
        );
        min = firstDay;
        max = lastDay;
        break;
      case "personalizado":
        min = configFaltas.rango?.inicio
          ? new Date(configFaltas.rango.inicio)
          : inicioPeriodo;
        max = configFaltas.rango?.fin
          ? new Date(configFaltas.rango.fin)
          : finPeriodo;
        break;
      default:
        // Si no se reconoce el tipo, usar el periodo por defecto
        min = inicioPeriodo;
        max = finPeriodo;
        break;
    }
    setFechaInicial(min);
    setFechaFinal(max);
    // Ahora aplicar restricción por tipo de días permitidos
    const captura = configFaltas.capturaDias;

    if (captura) {
      if (captura.tipo === "primeros") {
        const nuevaMax = new Date(inicioPeriodo);
        nuevaMax.setDate(nuevaMax.getDate() + captura.cantidad - 1);
        max = nuevaMax < max ? nuevaMax : max;
      } else if (captura.tipo === "ultimos") {
        const nuevaMin = new Date(finPeriodo);
        nuevaMin.setDate(nuevaMin.getDate() - captura.cantidad + 1);
        min = nuevaMin > min ? nuevaMin : min;
      } else if (captura.tipo === "personalizado") {
        if (captura.rango?.inicio) min = new Date(captura.rango.inicio);
        if (captura.rango?.fin) max = new Date(captura.rango.fin);
      }
    }
  }, [selectedNomina, configSistema]);

  useEffect(() => {
    const fetchFalta = async () => {
      if (idFalta) {
        try {
          const response = await axiosPrivate.get(`/NOM/faltas/${idFalta}`);

          const { numero, dias } = response.data;
          console.log("Falta response:", numero);
          const empleadoEncontrado = empleados.find(
            (emp) => emp.numero === numero
          );
          if (empleadoEncontrado) {
            setEmpleado(empleadoEncontrado);
          } else {
            console.warn("Empleado no encontrado en la lista");
          }
          setFechas(dias.map((f) => new Date(f))); // Asegúrate que sean objetos Date
        } catch (error) {
          console.error("Error al cargar la falta:", error);
        }
      }
    };
    if (empleados.length > 0 && idFalta) {
      fetchFalta();

      //cargarFalta(); // extrae el código de arriba en una función
    }
  }, [empleados, idFalta]);

  addLocale("es", {
    firstDayOfWeek: 1,
    dayNames: [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
    ],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
    monthNames: [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ],
    monthNamesShort: [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic",
    ],
    today: "Hoy",
    clear: "Limpiar",
  });
  const handleBack = () => {
    navigate(-1);
  };
const validarDiaPermitido = (modulo) => {
  if (!selectedNomina || !configSistema) return true; // permitir por defecto si falta info

  const config = configSistema[modulo];
  if (!config) return true;

  const hoy = new Date();
  const fechaInicio = parse(selectedNomina.FechaInicial, "dd/MM/yyyy", new Date());
  const fechaFin = parse(selectedNomina.FechaFinal, "dd/MM/yyyy", new Date());

  let min = fechaInicio;
  let max = fechaFin;

  // Validación base por tipo de fechas
  switch (config.validacionFechas) {
    case "periodo":
      break; // ya está bien
    case "mes":
      min = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), 1);
      max = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth() + 1, 0);
      break;
    case "personalizado":
      if (config.rango?.inicio) min = new Date(config.rango.inicio);
      if (config.rango?.fin) max = new Date(config.rango.fin);
      break;
    default:
      // Opcional: puedes dejarlo vacío o agregar un log
      break;
  }

  const captura = config.capturaDias;
  if (captura) {
    if (captura.tipo === "primeros") {
      const nuevaMax = addDays(min, captura.cantidad - 1);
      if (nuevaMax < max) max = nuevaMax;
    } else if (captura.tipo === "ultimos") {
      const nuevaMin = subDays(max, captura.cantidad - 1);
      if (nuevaMin > min) min = nuevaMin;
    } else if (captura.tipo === "personalizado") {
      if (captura.rango?.inicio) min = new Date(captura.rango.inicio);
      if (captura.rango?.fin) max = new Date(captura.rango.fin);
    }
  }

  return !isBefore(hoy, min) && !isAfter(hoy, max);
};
  const handleClick = () => {
    if (!empleado) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Seleccione un empleado",
        life: 3000,
      });
      return;
    }
    if (fechas.length === 0) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Seleccione fechas",
        life: 3000,
      });
      return;
    }

    if (!validarDiaPermitido("faltas")) {
      toast.current.show({ 
        severity: "error",
        summary: "Error", 
        detail: "No se permite capturar faltas en esta fecha.",
        life: 3000,
      });
      return;
    }



    confirmPosition("top");
  };

  const accept = async () => {
    console.log("empleado:", empleado );
    const aDates = fechas.map((f) => format(f, "yyyy/MM/dd"));
    const data = {
      empleado,
      fechas: aDates,
      idNomina: selectedNomina.idNomina,
      periodo: `${
        selectedNomina.YearPeriodo
      }-${selectedNomina.PeriodoActual.toString().padStart(2, "0")}`,
    };

    try {
      const response = idFalta
        ? await axiosPrivate.put(`/NOM/faltas/${idFalta}`, data)
        : await axiosPrivate.post("NOM/faltas", data);
      console.log("Faltas response:", response.data);

      toast.current.show({
        severity: "success",
        summary: "Guardado",
        detail: response?.data.msg,
        life: 3000,
      });

      if (!idFalta) {
        setEmpleado(null);
        setFechas([]);
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "No se pudo guardar",
        life: 3000,
      });
    }
  };

  const confirmPosition = (position) => {
    confirmDialog({
      message: "¿Está seguro de guardar el registro?",
      header: "Confirmación",
      icon: "pi pi-question-circle",
      position,
      accept,
      acceptLabel: "Sí, guardar",
      rejectLabel: "Cancelar",
    });
  };

  return (
    <div className="p-m-4">
      <Toast ref={toast} />
      <ConfirmDialog />
      <Card title="Captura de Faltas">
        <div className="mb-3">
          <div className="mb-3 flex justify-content-between">
            <Button
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-secondary"
              onClick={handleBack}
            />
            <Button
              label="Ver registros"
              icon="pi pi-list"
              className="p-button-info"
              onClick={() =>
                navigate(
                  `/faltas/listado?periodo=${
                    selectedNomina?.YearPeriodo
                  }-${selectedNomina?.PeriodoActual.toString().padStart(2, "0")}`
                )
              }
            />
          </div>
        </div>
        <div className="p-fluid grid">
          <div className="col-12 md:col-6">
            <label htmlFor="empleado" className="font-bold block mb-2">
              Empleado
            </label>
            <Dropdown
              id="empleado"
              value={empleado}
              options={empleados}
              onChange={(e) => setEmpleado(e.value)}
              optionLabel="label"
              placeholder="Seleccione un empleado"
              showClear
              filter
              className="w-full mb-3"
            />
          </div>

          <div className="col-12 md:col-6">
            <label htmlFor="fechas" className="font-bold block mb-2">
              Fechas de Faltas
            </label>
            <Calendar
              id="fechas"
              value={fechas}
              onChange={(e) => setFechas(e.value)}
              selectionMode="multiple"
              minDate={fechaInicial}
              maxDate={fechaFinal}
              readOnlyInput
              dateFormat="dd/mm/yy"
              showButtonBar
              className="w-full mb-3"
              placeholder="Seleccione las faltas"
            />
          </div>

          <div className="col-2 flex justify-content-end">
            <Button
              label="Guardar"
              icon="pi pi-save"
              onClick={handleClick}
              className="p-button-primary"
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Faltas;
